import { render, staticRenderFns } from "./CarDimensionsField.vue?vue&type=template&id=cf97c40c&scoped=true"
import script from "./CarDimensionsField.vue?vue&type=script&lang=ts"
export * from "./CarDimensionsField.vue?vue&type=script&lang=ts"
import style0 from "./CarDimensionsField.vue?vue&type=style&index=0&id=cf97c40c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf97c40c",
  null
  
)

export default component.exports